import { METRIC_SWITCH_MAP } from '@utils/metrics';
import { DASHBOARD_TYPE } from '@src/utils/constants';
import { showRollingWindow } from '@src/utils/dashboard/rollingWindow';
import { ALL_TRAFFIC } from '@src/utils/filter';
import moment from 'moment';
import { atomWithStorage, createJSONStorage } from 'jotai/utils'
import { buildErrorRule } from '@src/utils/filter/createErrorCodeFilter';

const storage = createJSONStorage(() => sessionStorage)
export const getChoiceAtom = (id) => atomWithStorage(`error-migration-choice-${id}`, '', storage)


export const createTempDashboardConfig = (base) => {
  const { currentErrorCode, interval: oldInterval, metric } = base;
  const dashboardName = `EA: ${currentErrorCode.slice(0, 15)} ${moment().format()}`;

  const interval = { ...oldInterval };
  delete interval.scrollingWindow

  const selectedMetric = METRIC_SWITCH_MAP[metric] || metric;

  return {
    config: {
      // usecase key enforces the new drill-down workflow (without injector layer)
      usecaseKey: 'error-diag-dashboard',
      metricsChartContainer: {
        metric: selectedMetric,
        metrics: [selectedMetric],
      },
      common: {
        appliedFilters: [ALL_TRAFFIC],
        interval,
      },
      'module:trends': {
        base: {
          compareFilters: [],
          metricFilter: [{
            metric: selectedMetric,
            rule: buildErrorRule(selectedMetric, [currentErrorCode]),
            meta: { type: "error-code" }
          }]
        },
      },
      toggles: {
        sections: {
          summary: false,
        }
      },
      metricPanel: {
        size: 'm',
        diagnosticsMode: true,
        logAxis: true,
        unit: '#',
      }
    },
    dashboardName
  };
}

export const createSavedDashboardConfig = (base) => {

  const { currentErrorCode, interval: oldInterval, metric } = base;
  const dashboardName = `EA: ${currentErrorCode.slice(0, 15)} ${moment().format()}`;

  const interval = { ...oldInterval };
  delete interval.scrollingWindow

  const selectedMetric = METRIC_SWITCH_MAP[metric] || metric;

  return {
    config: {
      title: `error ${interval.from} - ${interval.to}`,
      dashboard: 'trends',
      start: interval.from,
      end: interval.to,
      meta: {
        // true if it's not a custom date as compare had rolling feature support
        rollingWindow: showRollingWindow(interval),
      },
      state: {
        metricsChartContainer: {
          metric: selectedMetric,
          metrics: [selectedMetric],
        },
        common: {
          appliedFilters: [ALL_TRAFFIC],
          interval,
        },
        'module:trends': {
          base: {
            compareFilters: [],
            metricFilter: [{
              metric: selectedMetric,
              rule: buildErrorRule(selectedMetric, [currentErrorCode]),
              meta: { type: "error-code" }
            }]
          },
        },
        toggles: {
          sections: {
            summary: false,
          }
        },
        metricPanel: {
          size: 'm',
          diagnosticsMode: true,
          logAxis: true,
          unit: '#',
        }
      }
    },
    name: dashboardName,
    isPublic: false,
    isSaved: true,
    dashboardTypeId: DASHBOARD_TYPE.TRENDS,
  };

}
